export default __webpack_public_path__ + "static/media/brown.e2ee5f81.png";